<template>
	<div>
		<div class="columns is-multiline">
			<div
				v-for="variant in variant_list"
				class="column is-full pb-0">
				<div
					class="columns is-mobile is-multiline width-full is-variable is-0">
					<div class="column is-size-5 is-3 is-half-mobile">
						<div>
							<label
								ref="choices_list_labels"
								class="button is-static"
								:style="
									'min-width:' +
									minLabelWidth +
									';display: flex;border-radius: 0;'
								"
								>{{ variant.name }}:</label
							>
						</div>
					</div>
					<div class="column">
						<div class="select w100-mobile">
							<select
								ref="choices_list_values"
								@change="updateChoices"
								class="font-size-initial w100-mobile"
								style="border-radius: 0px">
								<option
									selected
									disabled
									value="">
									Choose an Option
								</option>
								<option
									v-for="option in variant.options"
									v-html="option"
									:value="option"></option>
							</select>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<style type="text/css" scoped>
	.font-size-initial {
		font-size: initial;
	}
</style>
<script type="text/javascript">
	import Vue from "vue";
	export default {
		props: ["choice_list_prop", "availability_prop", "inventory_prop"],
		data() {
			return {
				isMounted: false,
			};
		},
		mounted() {
			this.$data.isMounted = true;
			this.updateChoices(); //Quantity is not updated until it is changed so this is needed.
		},
		computed: {
			inventory() {
				try {
					// This is done so that null is not returned
					if (JSON.parse(this.inventory_prop) != null) {
						return JSON.parse(this.inventory_prop);
					} else {
						return {};
					}
				} catch (error) {
					console.error(error);
					return {};
				}
			},
			variant_list() {
				let list = [];
				if (this.inventory.variants.variants) {
					Object.keys(this.inventory.variants.variants).forEach(
						(variantKey) => {
							let variantOption = {
								name: variantKey,
								options: this.inventory.variants.variants[variantKey],
							};
							list.push(variantOption);
						}
					);
				}
				return list;
			},
			choices() {
				return this.inventory.variants.variants
					? Object.keys(this.inventory.variants.variants)
					: [];
			},
			availability() {
				if (this.$props.availability_prop) {
					return this.$props.availability_prop;
				}
				return false;
			},
			quantity() {
				return parseInt(this.availability);
			},
			minLabelWidth() {
				let minWidth = 0;
				if (this.isMounted) {
					if (this.$refs.choices_list_labels) {
						this.$refs.choices_list_labels.forEach(function (item) {
							console.debug(item);
							item.getBoundingClientRect().width > minWidth
								? (minWidth = item.getBoundingClientRect().width)
								: null /* do nothing*/;
						});
					}
				}
				return minWidth;
			},
		},
		methods: {
			choices_values() {
				let array_of_values = [];
				if (!!this.$refs.choices_list_values) {
					//If this.$refs.choices_list_values is not equal to null or undefined
					for (
						let counter = 0,
							count = this.$refs.choices_list_values.length;
						counter < count;
						counter++
					) {
						array_of_values.push({
							choice: this.choices[counter],
							value: this.$refs.choices_list_values[counter].value,
						});
					}
				}

				// Since the customer will not be able to select a quantity when only one product available, the quantity attribute will just be set as 1
				if (this.quantity == 1) {
					array_of_values.push({ choice: "quantity", value: 1 });
				} else {
					array_of_values.push({
						choice: "quantity",
						value: this.$store.getters.productQuantity,
					});
				}
				return array_of_values;
			},
			updateChoices() {
				this.$store.dispatch("set_choices", this.choices_values());
				this.$store.dispatch(
					"set_product_variation_price",
					(Math.random() * 1000).toFixed(2)
				);
			},
		},
	};
</script>
